import AsyncButton from '~/components/AsyncButton.tsx'
import { Button } from '~/components/Button.tsx'
import { useExitAdminImpersonation } from '~/features/admin/workspaces/data.tsx'

interface Props {
  email: string
}

function ImpersonatorBanner({ email }: Props) {
  const exitImpersonation = useExitAdminImpersonation()

  return (
    <div className="admin-banner">
      <div className="admin-banner__container container">
        <div>
          👀 You are using Transloadit on behalf of <strong>{email}</strong>
        </div>

        <Button asChild variant="secondary" size="compact">
          <AsyncButton
            status={exitImpersonation.status}
            className="btn btn--secondary btn--compact admin-banner__button"
            onClick={() => exitImpersonation.execute()}
          >
            Switch back
          </AsyncButton>
        </Button>
      </div>
    </div>
  )
}

export default ImpersonatorBanner
